// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectroller .el-input__suffix{right:-1.563vw!important}", ""]);
// Exports
module.exports = exports;
